import { Height } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  styled,
  Typography,
  useMediaQuery,
  Button,
  AvatarGroup,
  Avatar
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import UserBannerScores from '../../components/user-banner-scores';
import createAxiosInstance from '../../api/axiosConfig';
import { CLAN_DETAIL_API, USER_BY_IDS_API } from '../../api/endpoint';
import dmdBg from '../../assets/dmdBg.png';
import rubyBg from '../../assets/rubyBg.png';
import gldBg from '../../assets/goldBg.png';
import slvBg from '../../assets/slvBg.png';
import dmdlottie from '../../assets/diamond.json';
import slvlottie from '../../assets/silverBG.json';
import goldLottie from '../../assets/goldBG.json';
import rubyLottie from '../../assets/rubyBG.json';
import mpbg from '../../assets/mpbg.png';
import hofbg from '../../assets/hofbg.png';
import treasurebg from '../../assets/treasurebg.png';
import mpLottie from '../../assets/mpBG.json';
import treasureLottie from '../../assets/treasureBG.json';
import hofLottie from '../../assets/hofBG.json';
import milestoneLottie from '../../assets/milestoneBG.json';
import axios from 'axios';
import { Player } from '@lottiefiles/react-lottie-player';
import backBtn from '../../assets/backGold.png';

const ClanDetail = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { item } = location.state || {};
  const [stopExecution, setStopExecution] = useState<boolean | null>(false);
  const isFetching = useRef(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [clanDetail, setClanDetail] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState<any>(null);

  const handleBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const fetchClanDetail = async () => {
    if (!stopExecution) {
      if (isFetching.current) return;
      isFetching.current = true;
      console.log('clan id', item.id);
      try {
        const axiosInstance = createAxiosInstance(false);
        const response = await axiosInstance.get(`${CLAN_DETAIL_API}${item.clanId}`);
        console.log('ClanDetail', response.data.data);
        const userIds = response.data.data?.clan_members.map((item: any) => item.member_id).join(',');
        console.log('userIds', userIds);
        const userData = await axiosInstance.get(`${USER_BY_IDS_API}${userIds}`);
        setUserDetail(userData?.data.data);
        if (!response?.data?.data?.length) {
          setStopExecution(true);
        }

        setClanDetail(response.data.data);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
        }
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    }
  };
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-container': {
      backdropFilter: 'blur(7px)'
    },
    '& .MuiDialog-paper': {
      borderRadius: theme.breakpoints.up('sm') ? '20px' : '18px',
      backdropFilter: 'blur(7px)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
      width: useMediaQuery(theme.breakpoints.down('sm')) ? '85%' : '60%',
      maxWidth: 'none',
      height: useMediaQuery(theme.breakpoints.down('sm')) ? '87%' : '80%',
      backgroundColor: 'transparent'
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      color: 'none'
    }
  }));

  useEffect(() => {
    if (item) {
      setOpen(true);
      fetchClanDetail();
    }
  }, []);

  console.log('clanDetail', clanDetail);

  return (
    <div>
      <BootstrapDialog open={open} maxWidth="md" fullWidth scroll="body">
        <DialogContent
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            scrollbarWidth: 'none',
            background: 'white'
          }}>
          <Box style={{ height: isMobile ? '40%' : '70%', borderRadius: '20px' }}>
            <img
              src={item.coverImage}
              alt="clanImage"
              style={{ height: '100%', width: '100%', borderRadius: '20px' }}></img>
          </Box>
          <Button
            onClick={handleBackClick}
            style={{
              position: 'absolute',
              top: 16,
              left: 16,
              zIndex: 2,
              cursor: 'pointer',
              boxShadow: 'rgba(0, 0, 0, 0.2) 0px 8px 24px',
              color: 'black'
            }}>
            <img src={backBtn} alt={'backBtn'}></img>
          </Button>
          <Box style={{ position: 'absolute', top: isMobile ? '30%' : '55%', left: '5%', color: 'white' }}>
            <Typography style={{ fontSize: isMobile ? '16px' : '24px', fontWeight: 800, fontFamily: 'Baloo2' }}>
              {clanDetail?.clan_name}
            </Typography>
            <Typography style={{ fontSize: isMobile ? '12px' : '16px', fontFamily: 'Baloo2' }}>
              {clanDetail?.handle}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" mb={2} m={'3% 5%'}>
            <AvatarGroup max={5}>
              {userDetail?.map((item: any, idx: number) => (
                <Avatar
                  key={idx}
                  alt={item.handle}
                  src={
                    item.defaultAvatar
                      ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/${item.avatar}`
                      : `${process.env.REACT_APP_DEFAULT_AVATAR}/${item.uid}/PROFILE/IMAGES/medium/${item.avatar}`
                  }
                />
              ))}
            </AvatarGroup>
            <Typography ml={2} fontWeight="bold">
              {`${userDetail?.length} champs`}
            </Typography>
          </Box>
          <Grid item xs={12} md={4} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <UserBannerScores
              clanCounters={clanDetail?.clan_members_summary}
              isMobile={isMobile}
              clanCoins={clanDetail?.clan_coins}
              clanId={clanDetail?.clan_id}
            />
          </Grid>
          <Box style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
            <Box style={{ flex: 1, margin: isMobile ? '5% 10%' : '0 5%', width: isMobile ? '100%' : '50%' }}>
              <Typography
                sx={{
                  background:
                    'linear-gradient(89.92deg, #E02780 0.07%, #FF5D83 0.08%, #B465FF 38.02%, #FF9D32 62.98%, #FF7A52 83.45%, #FF4FF1 99.93%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 400,
                  fontSize: '16px'
                }}>
                Valuables
              </Typography>

              <Box style={{ display: 'flex', gap: '5px', justifyContent: 'space-between', margin: '5% 0' }}>
                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={dmdBg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-15px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={dmdlottie} style={{ width: '40px', height: '43px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary?.diamond?.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Diamond</Typography>
                </Box>

                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={rubyBg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-19px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={rubyLottie} style={{ width: '40px', height: '43px' }} />
                    <Typography style={{ fontSize: '12px' }}>{`x ${clanDetail?.clan_members_summary.ruby}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Ruby</Typography>
                </Box>
                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={gldBg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-19px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={goldLottie} style={{ width: '40px', height: '43px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.gold.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Gold</Typography>
                </Box>
                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={slvBg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-19px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={slvlottie} style={{ width: '40px', height: '43px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.silver.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>silver</Typography>
                </Box>
              </Box>
            </Box>
            <Box style={{ flex: 1 }}>
              <Typography
                sx={{
                  background:
                    'linear-gradient(89.92deg, #E02780 0.07%, #FF5D83 0.08%, #B465FF 38.02%, #FF9D32 62.98%, #FF7A52 83.45%, #FF4FF1 99.93%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 400,
                  fontSize: '16px',
                  marginLeft: '10%' // Optional: for better visibility
                }}>
                Badges
              </Typography>
              <Box
                style={{ display: 'flex', margin: isMobile ? '5% 10%' : '13% 10%', justifyContent: 'space-between' }}>
                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={mpbg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={mpLottie} style={{ width: '40px', height: '43px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.masterpiece.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Master Piece</Typography>
                </Box>

                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={treasurebg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={treasureLottie} style={{ width: '27px', height: '30px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.wonders.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Treasure</Typography>
                </Box>

                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={hofbg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={hofLottie} style={{ width: '27px', height: '30px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.hall_of_fame.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Hall of Frame</Typography>
                </Box>
                <Box style={{ position: 'relative', textAlign: 'center', display: 'inline-block' }}>
                  {/* Background Image */}
                  <img alt="dmd" src={hofbg} style={{ display: 'block', width: '100%' }} />

                  {/* Lottie Overlay */}
                  <Box
                    style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      flexDirection: 'column'
                    }}>
                    <Player autoplay loop src={milestoneLottie} style={{ width: '27px', height: '30px' }} />
                    <Typography
                      style={{
                        fontSize: '12px'
                      }}>{`x ${clanDetail?.clan_members_summary.milestone?.toString().padStart(2, '0') || '00'}`}</Typography>
                  </Box>

                  {/* Label Below */}
                  <Typography style={{ fontSize: '12px', marginTop: 4 }}>Milestone</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default ClanDetail;
